var _style, _defs, _polyline, _polyline2, _polyline3, _polyline4, _defs2, _rect, _path, _path2, _line, _line2, _line3, _path3, _path4, _line4, _line5, _line6, _path5, _line7, _line8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpenses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 54.3",
    style: {
      enableBackground: "new 0 0 96 54.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\r\n\t\t.st0{clip-path:url(#SVGID_2_);fill:none;stroke:#0A2967;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#0A2967;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st2{clip-path:url(#SVGID_4_);fill:none;stroke:#0A2967;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 96,
    height: 54.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "22.1,11.8 22.1,1.2 94.8,1.2 94.8,11.3  "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "94.8,20.5 94.8,33.2 83.9,33.2  "
  }))), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "11.3,21.1 11.3,11.8 83.9,11.8 83.9,21.8 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "83.9,31 83.9,43.7 73.9,43.7 "
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    y: 0,
    width: 96,
    height: 54.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 21.1,
    className: "st2",
    width: 72.7,
    height: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.7,32.9c3.4,0,6.1-2.7,6.1-6.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.7,41.2c3.4,0,6.1,2.7,6.1,6.1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11.7,
    y1: 32.9,
    x2: 11.7,
    y2: 41.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 23.5,
    y1: 47.4,
    x2: 17.8,
    y2: 47.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 17.8,
    y1: 26.8,
    x2: 23.5,
    y2: 26.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.5,41.2c-3.4,0-6.1,2.7-6.1,6.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.5,32.9c-3.4,0-6.1-2.7-6.1-6.1"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 63.5,
    y1: 41.2,
    x2: 63.5,
    y2: 32.9
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 51.6,
    y1: 26.8,
    x2: 57.4,
    y2: 26.8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 57.4,
    y1: 47.4,
    x2: 51.6,
    y2: 47.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43,43.6c-0.6,0.1-1.1,0.2-1.7,0.2c-4,0-7.2-3-7.2-6.8c0-3.7,3.2-6.8,7.2-6.8c0.6,0,1.2,0.1,1.7,0.2"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 32.2,
    y1: 35.3,
    x2: 40.6,
    y2: 35.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 32.2,
    y1: 39.4,
    x2: 40.6,
    y2: 39.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenses);
export default __webpack_public_path__ + "static/media/Expenses.cd84958369aebd06839d8df7fddf963f.svg";
export { ForwardRef as ReactComponent };